"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./DevlinkAllServicesHero.module.css";

export function DevlinkAllServicesHero({
  as: _Component = _Builtin.Section,
  heroTitle = "A helping hand for all your home tech",
  search,
  categoryChips,
  imageSlot,
  showImageSource = true,
  imageSource = "https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/662c31c5e0fba366f2407470_allservices-hero-img.jpg",
}) {
  return (
    <_Component
      className={_utils.cx(_styles, "ht-all-service-hero")}
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "ht-bg-fill-container")}
        tag="div"
      >
        <_Builtin.Image
          className={_utils.cx(_styles, "image-58")}
          loading="lazy"
          width="auto"
          height="auto"
          alt=""
          src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6604a9049660b46d146767ff_homepage-hero-bg-blob.svg"
        />
        <_Builtin.Image
          className={_utils.cx(_styles, "image-59")}
          loading="lazy"
          width="auto"
          height="auto"
          alt=""
          src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6604a9049660b46d146767ff_homepage-hero-bg-blob.svg"
        />
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "ht-container", "lg")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "ht-contained-hero")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "ht-contained-hero-content")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "ht-hero-content")}
              tag="div"
            >
              <_Builtin.Heading
                className={_utils.cx(_styles, "txt-display", "txt-n000")}
                tag="h1"
              >
                {heroTitle}
              </_Builtin.Heading>
              <_Builtin.Block
                className={_utils.cx(_styles, "small-1")}
                tag="div"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "ht-hero-search-wrapper")}
                tag="div"
              >
                {search}
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "small")}
                tag="div"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "ht-chip-group")}
                tag="div"
              >
                {categoryChips}
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(
              _styles,
              "ht-all-service-hero-img",
              "desktop-tablet-only"
            )}
            tag="div"
          >
            {imageSlot}
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, "mobile-only")} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, "medium-2")} tag="div" />
        <_Builtin.Block
          className={_utils.cx(_styles, "ht-all-service-hero-img")}
          tag="div"
        >
          {imageSlot ??
            (showImageSource ? (
              <_Builtin.Image
                className={_utils.cx(_styles, "ht-inner-img")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src={imageSource}
              />
            ) : null)}
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
